var Handlebars = require("C:\\TeamCityAgents\\02\\work\\bbe988d6cf529cbd\\CMS\\App_Themes\\DeleteKenticoFramework\\node_modules\\handlebars\\runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"container container--narrow\">\r\n    <div class=\"jg-imagery__empty\">\r\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna\r\n        aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\r\n    </div>\r\n</div>\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/components/jg-imagery/html/jg-imagery-empty.hbs
// module id = GENp
// module chunks = 0